import axios from 'axios';
import authHeader from './auth-header';

const API_URL = process.env.VUE_APP_API_BASE_URL;
const UPLOAD_API_PATH = `${API_URL}/backoffice/file-upload-public`;
const GET_FILE_API_PATH = `${API_URL}/backoffice/get-file`;



async function upload(params) {
  const response = await axios.post(UPLOAD_API_PATH, params, { headers: authHeader() });
  return response.data;
}

async function get(id) {
  const params = {id: id}
  const response = await axios.post(GET_FILE_API_PATH, params, { headers: authHeader() });
  return response.data;
}

export default {
  upload,
  get
};